import { render } from "./ConsistencyCheckSection.vue?vue&type=template&id=373c4112&scoped=true"
import script from "./ConsistencyCheckSection.vue?vue&type=script&lang=js"
export * from "./ConsistencyCheckSection.vue?vue&type=script&lang=js"

import "./ConsistencyCheckSection.vue?vue&type=style&index=0&id=373c4112&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373c4112"]])

export default __exports__